import ProgressBar from "app/components/ProgressBar/ProgressBar";
import AsianFooter from "app/screens/AsianEventsScreen/components/AsianFooter/AsianFooter";
import type { CompetitionType } from "app/types/competitionType";
import React, { Component } from "react";
import GetNoEventsContent from "../GetNoEventsContent/GetNoEventsContent";
type Props = {
  competitionList: CompetitionType[];
  isCompetitionListLoading: boolean;
  setCompetitionListLoading: boolean;
  favouritesLoading: boolean;
  selectedCompetitionType: string;
  bookmarksTotal: number;
  bookmarksOnly: boolean;
  favouritesOnly: boolean;
  isUserLoaded: boolean;
  time: string;
  selectedLanguage: string;
  showUnsummarizedMarketsModal: boolean;
  checkClickEvent: (...args: Array<any>) => any;
  renderCompetitionList: (...args: Array<any>) => any;
  utilizeWindowList: any;
  renderEndOfList: (...args: Array<any>) => any;
};

class CompetitionsScreenContents extends Component<Props> {
  render() {
    const {
      competitionList,
      isCompetitionListLoading,
      setCompetitionListLoading,
      favouritesLoading,
      selectedCompetitionType,
      bookmarksTotal,
      bookmarksOnly,
      favouritesOnly,
      isUserLoaded,
      time,
      selectedLanguage,
      showUnsummarizedMarketsModal,
      checkClickEvent,
      renderCompetitionList,
      utilizeWindowList,
      renderEndOfList,
    } = this.props;
    let content = <div />;

    // Check that there is a list to display, otherwise show blank state message
    if (
      competitionList.length === 0 &&
      !isCompetitionListLoading &&
      !setCompetitionListLoading &&
      !favouritesLoading
    ) {
      content = (
        <GetNoEventsContent
          selectedCompetitionType={selectedCompetitionType}
          bookmarksTotal={bookmarksTotal}
          bookmarksOnly={bookmarksOnly}
          favouritesOnly={favouritesOnly}
          isUserLoaded={isUserLoaded}
          time={time}
        />
      );
    } else if (
      competitionList.length === 0 &&
      (isCompetitionListLoading || favouritesLoading)
    ) {
      content = (
        <React.Fragment>
          <ProgressBar isLoading={isCompetitionListLoading} />
          <AsianFooter className={"no-content"} />
        </React.Fragment>
      );
    } else {
      content = (
        <div
          className={`competitions-screen__wrapper ${selectedLanguage.toLowerCase()} ${
            showUnsummarizedMarketsModal === true ? "suspended" : ""
          }`}
          onClick={checkClickEvent}
        >
          <div>{renderCompetitionList}</div>

          {!utilizeWindowList && (
            <div>
              <div className="competitions-screen__list__bottom-spacer" />
              {this.props.competitionList.length > 0 && (
                <div>{renderEndOfList}</div>
              )}
              <AsianFooter />
            </div>
          )}
        </div>
      );
    }

    return <>{content}</>;
  }
}

export default CompetitionsScreenContents;
